// @ai-generated 2026-09-17T10:27:43+00:00 by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)
import { type AbstractAgent } from '@ag-ui/client';
import { useCallback, useEffect, useReducer } from 'react';

/**
 * Drives an AG-UI agent from React.
 */
export function useChatAgent(agent: AbstractAgent) {
    const [, onAgentChanged] = useReducer((version: number) => version + 1, 0);

    useEffect(() => {
        const subscription = agent.subscribe({
            onMessagesChanged: () => onAgentChanged(),
            onRunInitialized: () => onAgentChanged(),
            onRunFinalized: () => onAgentChanged(),
            onRunFailed: () => onAgentChanged(),
        });
        return () => subscription.unsubscribe();
    }, [agent]);

    const submit = useCallback(
        (value: string) => {
            agent.addMessage({ id: crypto.randomUUID(), role: 'user', content: value });
            void agent.runAgent();
        },
        [agent],
    );

    const stop = useCallback(() => agent.abortRun(), [agent]);

    return { messages: agent.messages, isRunning: agent.isRunning, submit, stop };
}
